module.exports = __webpack_public_path__ + "imgs/leafwell-logo-black.1b4b5061b67b7499cf920d3d9a078d51.png";